'use client';

import { useEffect } from 'react';
import { api } from '~/libs/api';

const MINUTE = 60_000;

export const AccountPrefetch = () => {
  const utils = api.useUtils();

  useEffect(() => {
    void utils.account.savedTrips.prefetch(undefined, { staleTime: MINUTE });
    void utils.account.bookedTrips.prefetch(undefined, { staleTime: MINUTE });
    void utils.account.preferences.prefetch(undefined, { staleTime: MINUTE });

    if (process.env.NEXT_PUBLIC_FF_REFER_ENABLED === 'true') {
      void utils.referral.getCodeAndCredits.prefetch(undefined, { staleTime: MINUTE });
    }

    if (process.env.NEXT_PUBLIC_FF_REWARDS_ENABLED === 'true') {
      void utils.account.loyaltyTiers.prefetch(undefined, { staleTime: 30 * MINUTE });
    }
  }, [utils]);

  return null;
};
